module.exports = __webpack_public_path__ + "img/icon8.13c07b57.png";